var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("i", {
        directives: [
          {
            name: "b-toggle",
            rawName: "v-b-toggle.sidebar-1",
            modifiers: { "sidebar-1": true }
          }
        ],
        staticClass: "fas fa-bars fa-2x",
        staticStyle: { color: "white" }
      }),
      _vm._v(" "),
      _c("b-sidebar", {
        staticClass: "bg-dark",
        attrs: {
          id: "sidebar-1",
          width: "350px",
          "bg-variant": "dark",
          "text-variant": "light",
          "no-header": "",
          shadow: ""
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var hide = ref.hide
              return [
                _c(
                  "b-row",
                  { staticClass: "sticky-header shadow-sm" },
                  [
                    _c(
                      "b-col",
                      {
                        staticClass:
                          "p-2 d-flex justify-content-around no-wrap",
                        attrs: { cols: "12" }
                      },
                      [
                        _c(
                          "div",
                          [
                            _c("b-img", {
                              staticClass: "img",
                              attrs: { src: "/imgs/Logo-branca.png" }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c("i", {
                              staticClass: "fas fa-times fa-1x",
                              staticStyle: { cursor: "pointer" },
                              on: { click: hide }
                            })
                          ]
                        )
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "menu-scroll-area" },
                  [
                    _c(
                      "b-row",
                      { staticClass: "p-2" },
                      _vm._l(_vm.menus, function(menu, index) {
                        return _c(
                          "b-col",
                          {
                            key: index,
                            staticClass:
                              "mb-2 align-self-center itens rounded p-0",
                            staticStyle: { cursor: "pointer" },
                            attrs: { cols: "12" },
                            on: {
                              click: function($event) {
                                menu.childs
                                  ? (menu.visible = !menu.visible)
                                  : _vm.abrirLink(menu.rota)
                              }
                            }
                          },
                          [
                            menu.childs
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "b-toggle",
                                            rawName: "v-b-toggle",
                                            value: "collapse-" + index,
                                            expression: "'collapse-'+index"
                                          }
                                        ],
                                        staticClass:
                                          "d-flex justify-content-between align-items-center p-2"
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "mx-1",
                                                staticStyle: {
                                                  width: "25px",
                                                  height: "25px"
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  class:
                                                    "fas " +
                                                    menu.icon +
                                                    " fa-1x"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("h5", { staticClass: "m-0" }, [
                                              _vm._v(_vm._s(menu.title))
                                            ])
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("i", {
                                          class:
                                            "fas fa-arrow-" +
                                            (menu.visible ? "up" : "down") +
                                            " fa-1x"
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-collapse",
                                      { attrs: { id: "collapse-" + index } },
                                      _vm._l(menu.childs, function(
                                        child,
                                        index_child
                                      ) {
                                        return _c(
                                          "div",
                                          {
                                            key: index_child,
                                            staticClass: "mt-2 py-2 sub-item"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "pl-5",
                                                on: {
                                                  click: function($event) {
                                                    $event.stopPropagation()
                                                    return _vm.abrirLink(
                                                      child.rota
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v(_vm._s(child.title))]
                                            )
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  ],
                                  1
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex align-items-center p-2",
                                    on: {
                                      click: function($event) {
                                        $event.stopPropagation()
                                        return _vm.abrirLink(menu.rota)
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "mx-1",
                                        staticStyle: {
                                          width: "25px",
                                          height: "25px"
                                        }
                                      },
                                      [
                                        _c("i", {
                                          class: "fas " + menu.icon + " fa-1x"
                                        })
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("h5", { staticClass: "m-0" }, [
                                      _vm._v(_vm._s(menu.title))
                                    ])
                                  ]
                                )
                          ]
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7fa762bb", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7fa762bb","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_vertical_navbar/Main.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7fa762bb","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/adm_vertical_navbar/Main.vue
// module chunks = 2